import { FunctionComponent, useCallback } from 'react';
import { Input } from '@chakra-ui/react';
import { useNumberInput } from '@netiva/classifieds-ui';

import { useAppDispatch, useAppSelector } from '@/store';
import { adActions } from '@/store/ad';
import { AdAttribute } from '@/store/ad/types';

export type NumberInputProps = {
  attribute: AdAttribute;
};

export const NumberInput: FunctionComponent<NumberInputProps> = ({ attribute }) => {
  const dispatch = useAppDispatch();
  const { formData } = useAppSelector((state) => state.ad);

  const handleOnChange = useCallback(
    (value: string) => {
      const maxLength = attribute.maxLength;

      if (typeof maxLength === 'number' && maxLength > 0 && value.length > maxLength) {
        return;
      }
      dispatch(adActions.updateFormData({ key: attribute.id, value }));
    },
    [attribute.id, attribute.maxLength, dispatch]
  );

  const inputProps = useNumberInput({
    onChange: handleOnChange,
  });

  return (
    <Input
      name={attribute.name || attribute.id.toString()}
      value={formData[attribute.id]?.value || ''}
      {...inputProps}
    />
  );
};
